import {ApDynformsConfigBase, ApDynformsControltype} from './ap-dynforms-config-base';
import {TemplateRef} from '@angular/core';

/**
 * configuration for dynForm element which allows to inject templates from parent component
 * into our fieldset structure
 */
export class ApDynformsConfigTemplate extends ApDynformsConfigBase<TemplateRef<any>> {
  public controlType = ApDynformsControltype.Template;

  constructor(options: {
    key?: string,
    value?: TemplateRef<any>,
    cssClass?: string
  } = {}) {
    super(options);
  }
}

